<h2 mat-dialog-title>{{ inputData().title }}</h2>

<mat-dialog-content>
    <div class="p-4">
        <form>
            <div class="mce-form-section">
                <div class="mce-form-field-group">
                    <div>
                        <mat-form-field>
                            <mat-label>impedance magnitude</mat-label>
                            <input matInput type="number" placeholder="impedance magnitude"
                                   [formField]="form.z" />
                            <span matSuffix>Ω</span>
                            @for (error of form.z().errors(); track error.kind) {
                            <mat-error>{{ error.message }}</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div>
                        <mat-form-field>
                            <mat-label>X/R ratio</mat-label>
                            <input matInput type="number" placeholder="X/R ratio"
                                   [formField]="form.xrRatio" />
                            @for (error of form.xrRatio().errors(); track error.kind) {
                            <mat-error>{{ error.message }}</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="w-full">
        <mce-save-cancel [config]="saveCancelConfig()"
                         (action)="onSaveCancelAction($event)">
        </mce-save-cancel>
    </div>
</mat-dialog-actions>
